<template>
<Dialog v-model="visible" setting @setting="$emit('setting')">

  <template slot="title">
    <span class="title">{{$t('fan.control')}}</span>
  </template>

  <v-row justify="center" class="mb-5 pb-5">
    <v-btn icon width="140" height="140" @click="reverseDirection">
      <Fan size="120" :power="powerInner" :speed="speedAnimation" :direction="directionInner" animation></Fan>
    </v-btn>
  </v-row>

  <v-slider v-model="speedInner" min="0" :max="availableFanSpeeds.length-1" :tick-labels="availableFanSpeedLabels" thumb-label="always" track-color="grey" track-fill-color="primary" class="mx-5 pt-5"></v-slider>

  <template slot="actions">
    <v-btn outlined color="secondary" @click="powerInner=false">{{ $t('fan.stop') }}</v-btn>
    <v-spacer></v-spacer>
    <v-btn outlined color="primary" @click="powerInner=true">{{ $t('fan.start') }}</v-btn>
  </template>

</Dialog>
</template>

<script>
import BaseDialog from '@/components/utils/dialog/BaseDialog'
import Dialog from '@/components/utils/dialog/Dialog'
import Fan from '@/components/icon/Fan'

let delayHandler;

export default {
  name: 'FanControlDialog',
  mixins: [BaseDialog],
  components: {
    Dialog,
    Fan
  },
  props: {
    power: {
      type: Boolean,
      default: false
    },
    speed: {
      type: String
    },
    availableFanSpeeds: {
      type: Array
    },
    direction: {
      type: String
    },
    availableFanDirections: {
      type: Array
    }
  },
  computed: {
    powerInner: {
      get() {
        return this.power;
      },
      set(val) {
        this.$emit('update:power', val);
      }
    },
    speedInner: {
      get() {
        return this.availableFanSpeeds.indexOf(this.speed);
      },
      set(val) {
        if (delayHandler) clearTimeout(delayHandler);
        delayHandler = setTimeout(() => this.$emit('update:speed', this.availableFanSpeeds[val]), 500);
      }
    },
    speedAnimation() {
      return this.speed && this.power ? this.availableFanSpeeds.length / (this.availableFanSpeeds.indexOf(this.speed) + 1) : 0;
    },
    directionInner: {
      get() {
        return this.availableFanDirections.indexOf(this.direction);
      },
      set(val) {
        this.$emit('update:direction', this.availableFanDirections[val]);
      }
    },
    availableFanSpeedLabels() {
      return this.availableFanSpeeds.map(s => this.$t(`fan.${s}`));
    }
  },
  methods: {
    reverseDirection() {
      this.directionInner = this.directionInner ? 0 : 1;
    }
  }
}
</script>

<style>
.v-slider__track-container {
  border-radius: 3px;
  height: 6px !important;
}

.v-slider__track-background {
  border-radius: 4px;
}

.v-slider__track-fill {
  border-radius: 4px;
}
</style>
